import { Component } from "@angular/core";

@Component({
  template: `<div class="text-center p-7">
    <div
      class="bg-warning text-white rounded-full inline-flex justify-center items-center w-[48px] h-[48px]"
    >
      <patternlib-icon iconName="forbidden" size="24px" />
    </div>
    <p class="text-copy font-text text-gray-800 mt-5">
      {{ "access-denied-select-product-text" | translate }}
    </p>
  </div>`,
})
export class AccessDeniedSelectProductPage {}
